export const faqs = [
  {
    question: "「黑料五一」这个盘点专题主要整理什么内容？",
    answer:
      "专题围绕五一假期前后被公开讨论的热点展开，包括娱乐动态、影视综表现、品牌营销动作、出行消费争议与社交平台话题，并按时间顺序做时间线梳理，方便你快速补齐错过的内容。",
  },
  {
    question: "站内内容的信息来源和整理方式是什么？",
    answer:
      "我们只对公开可查的信息做归纳与背景补充，标注讨论发生的大致时间与所属分类。对于未经证实的说法，本站不做结论，也不会复述指向具体个人的指控，请读者自行交叉核对。",
  },
  {
    question: "为什么同一个事件在不同文章里会出现重复？",
    answer:
      "时间线、话题榜与分类盘点分别从不同角度切入，同一个高热度事件可能同时出现在时间线和分类文章中。我们会在正文里用不同视角展开，而不是简单复制段落。",
  },
  {
    question: "多久更新一次？会不会漏掉假期后期的内容？",
    answer:
      "假期期间保持每日两次整理，假期结束后仍会追加复盘与澄清类内容，一般在假期结束后的两周内完成补充，读者也可以订阅速报获取更新提醒。",
  },
  {
    question: "可以投稿线索或者指出内容错误吗？",
    answer:
      "可以。欢迎通过联系页面的表单说明具体情况，附上公开链接会更方便我们核实。若确有事实性错误，我们会在确认后尽快更正并在文末注明。",
  },
  {
    question: "站内内容可以转载吗？",
    answer:
      "欢迎在注明来源与原文链接的前提下引用观点，整篇转载请联系我们获取授权。用于商业用途的内容请提前沟通，避免产生使用上的分歧。",
  },
];